import { useLocation } from 'react-router-dom';

const useProduct = () => {
  const { pathname } = useLocation();

  if (/^\/sauna/i.test(pathname)) {
    return 'sauna';
  }

  return 'goboat';
};

export default useProduct;
